import {combineReducers} from 'redux'
import {cartReducer} from './cartReducer'
import {wishListReducer} from './wishListReducer'
import {userReducer} from './userReducer'
export default combineReducers({
    cart:cartReducer,
    wishlist:wishListReducer,
    user:userReducer,
   
})